/**
 * @name crud_patients_registrations.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\crud_patients_registrations.js
 */

//import { apiCall, getBaseDir } from './utils.js';

import TableBuilder from './table_builder.js';
import { userHasRole } from './utils.js';
import Swal from 'sweetalert2';

var moment = require('moment-timezone');

var getBaseDir = null, apiCall = null, getBranchNameFromId = null, getBusinessDoctorsListByBranchId = null, escapeSingleQuotes = null, userHasBranch = null, float2moeda = null;

var currentAccountUpdateInfo = null;
var selectedPatient = null;
var PatientsClass = null;

$(function () {
    // Detecta clique para alterar serviço de Conta Corrente de um Paciente
    $(document).on('click', '.js-patient-current-account-edit-service', function () {
        let currentAccountInfo = $(this).data('info');
        //console.log('currentAccountInfo', 'edit-service', currentAccountInfo);
        currentAccountUpdateInfo = currentAccountInfo;
        $("#modal-current-account-edit-transaction").modal('show');
        $('.js-current-account-edit-transaction-dialog-title-id').html(currentAccountInfo.ID);
        $("#edit_service_current_account_transaction_date").val(currentAccountInfo.DATA_FORMATTED);
        $("#edit_service_current_account_doctor").val(currentAccountInfo.STAFF_ID);
        $("#edit_service_current_account_service").val(currentAccountInfo.SERVICOS_ID);
        $("#edit_service_current_account_transaction_patient_type option").filter(function () {
            //may want to use $.trim in here
            return $(this).text().trim() == currentAccountInfo.TIPO_PACIENTE.trim();
        }).prop('selected', true);
        if (currentAccountInfo.STATUS == 'A') {
            $("#edit_service_current_account_transaction_attended").val('S');
        } else {
            $("#edit_service_current_account_transaction_attended").val('N');
        }
    });

    this.selectedServiceInfo = {
        serviceId: -1,
        quantity: 1,
        servicePrice: 0,
        discount: 0,
        unitPrice: 0,
        total: 0
    };
    let self = this;

    $(document).on('change', '#edit_current_account_service', function () {
        let serviceInfo = $('#edit_current_account_service option:selected').data('info');
        //console.log('serviceInfo', serviceInfo);
        self.selectedServiceInfo.serviceId = parseInt(serviceInfo.ID);
        self.selectedServiceInfo.quantity = 1;
        self.selectedServiceInfo.servicePrice = parseFloat(serviceInfo.VALOR).toFixed(2);
        self.selectedServiceInfo.discount = 0;
        self.selectedServiceInfo.unitPrice = parseFloat(self.selectedServiceInfo.servicePrice - (self.selectedServiceInfo.discount / self.selectedServiceInfo.quantity)).toFixed(2);
        self.selectedServiceInfo.total = parseFloat((self.selectedServiceInfo.unitPrice * self.selectedServiceInfo.quantity)).toFixed(2);

        $("#edit_current_account_transaction_service_amount").val(self.selectedServiceInfo.quantity);
        $("#edit_current_account_transaction_service_price").val(self.selectedServiceInfo.servicePrice);
        $("#edit_current_account_transaction_service_discount").val(self.selectedServiceInfo.discount);
        $("#edit_current_account_transaction_service_unit_price").val(self.selectedServiceInfo.unitPrice);
        $("#edit_current_account_transaction_service_total_price").val(self.selectedServiceInfo.total);
    });

    $(document).on('change', '#edit_current_account_transaction_service_amount', function () {
        let quantityValue = parseInt($(this).val());
        //console.log('quantityValue', quantityValue);
        self.selectedServiceInfo.quantity = quantityValue;
        self.selectedServiceInfo.unitPrice = parseFloat(self.selectedServiceInfo.servicePrice - (self.selectedServiceInfo.discount / self.selectedServiceInfo.quantity)).toFixed(2);
        self.selectedServiceInfo.total = parseFloat((self.selectedServiceInfo.unitPrice * self.selectedServiceInfo.quantity)).toFixed(2);

        $("#edit_current_account_transaction_service_unit_price").val(self.selectedServiceInfo.unitPrice);
        $("#edit_current_account_transaction_service_total_price").val(self.selectedServiceInfo.total);
    });

    $(document).on('change', '#edit_current_account_transaction_service_discount', function () {
        let discountValue = $(this).val();
        //console.log('discountValue', discountValue);
        self.selectedServiceInfo.discount = parseFloat(discountValue).toFixed(2);
        self.selectedServiceInfo.unitPrice = parseFloat(self.selectedServiceInfo.servicePrice - (self.selectedServiceInfo.discount / self.selectedServiceInfo.quantity)).toFixed(2);
        self.selectedServiceInfo.total = parseFloat((self.selectedServiceInfo.unitPrice * self.selectedServiceInfo.quantity)).toFixed(2);

        $("#edit_current_account_transaction_service_unit_price").val(self.selectedServiceInfo.unitPrice);
        $("#edit_current_account_transaction_service_total_price").val(self.selectedServiceInfo.total);
    });

    // Detecta envio do formulário de "Alteração de Serviço de Conta Corrente"
    $(document).on('submit', '.js-current-account-edit-transaction-form', function (e) {
        e.preventDefault();

        let serializeData = $(this).serializeArray();

        serializeData.push({
            name: 'edit_service_current_account_old_data',
            value: currentAccountUpdateInfo
        })

        $(".modal-current-account-edit-transaction-dialog").block(window._loader.loading);

        let selfBtn = this;
        $(selfBtn).find('button[type="submit"]').prop('disabled', true);

        apiCall({
            method: 'POST',
            endpoint: 'api/v1/patient/current_account_edit_service',
            data: serializeData,
            successCallback: function (res) {
                $(".modal-current-account-edit-transaction-dialog").unblock();
                $(selfBtn).find('button[type="submit"]').prop('disabled', false);

                window.toast({
                    error: res.error,
                    text: res.message
                })

                if (!res.error) {
                    $('.js-current-account-edit-transaction-form').trigger('reset');
                    $('#modal-current-account-edit-transaction').modal('hide');
                    if (PatientsClass)
                        PatientsClass.fetchPatientCurrentAccountData();
                }
            },
            errorCallback: function (err) {
                $(".modal-current-account-edit-transaction-dialog").unblock();
                $(selfBtn).find('button[type="submit"]').prop('disabled', false);
            }
        });
    });

    import('./utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        getBranchNameFromId = utils.getBranchNameFromId;
        getBusinessDoctorsListByBranchId = utils.getBusinessDoctorsListByBranchId;
        escapeSingleQuotes = utils.escapeSingleQuotes;
        userHasBranch = utils.userHasBranch;
        float2moeda = utils.float2moeda;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir() + 'pacientes/cadastros')
            return;

        PatientsClass = new PatientsRegistrations(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class PatientsRegistrations {
    constructor(onloadList = false, deps = {}) {
        this.deps = deps;

        this.operatorAllowedServices = [];

        this.patientsList = [];
        this.patientsTotal = 0;

        this.selectedBranch = -1;

        this.startDate = null;
        this.endDate = null;

        this.searchQuery = '';

        let self = this;

        // Resgata lista de serviços
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/employee/services',
            successCallback: function (res) {
                console.log('crud_patients_registrations.js/employee/services', 'onLoad', res);

                if (res.error) {

                } else {
                    self.operatorAllowedServices = res.data;
                    let html = '<option selected default value="">-- Selecione uma opção --</option>';
                    for (let i in res.data) {
                        let serviceObj = res.data[i];
                        if (serviceObj.SERVICO.toLowerCase().indexOf('cortesia') == -1 && (userHasRole('MANAGER') || userHasRole('COMMERCIAL_ASSISTANT')) && userHasBranch(14))
                            continue;
                        html += `
                            <option value="${serviceObj.ID}" data-service-time="${serviceObj.TEMPO_MINIMO}" data-info='${JSON.stringify(serviceObj)}'>${serviceObj.SERVICO}</option>
                        `;
                    }
                    $('#edit_current_account_service').html(html);
                    $('#edit_service_current_account_service').html(html);
                    $('#edit_current_account_comission_service').html(html);
                }
            },
            errorCallback(err) {
                console.error('ERROR', 'crud_patients_registrations.js/employee/services', 'onLoad', err);
            }
        });

        // Resgata lista de origens de pacientes
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/patient/origins',
            successCallback: function (res) {
                if (!res.error) {
                    let options = res.data;
                    let optionsHtml = '';
                    for (let i in options) {
                        let option = options[i];
                        optionsHtml += `<option value="${option.ID}">${option.ORIGEM}</option>`;
                    }
                    $("#edit_patient_origin").html(optionsHtml);
                }
            },
            errorCallback: function (err) {

            }
        });

        $('#edit_patient_postal_code').mask('00000-000', {
            onComplete: function (txt) { self.onFillPostalCode(txt); }
        });

        this.tableHandler = new TableBuilder({
            table: '#table-patients-list',
            tableBody: '.js-patients-registrations-table',
            data: [],
            rowsPerPage: parseInt($('.js-patients-per-page option:selected').val()),
            filter: false,
            maxPages: 0,
            customId: "CrudPatientsRegistrationsHandler",
            tableRowRenderer: function (rowData) {
                return self.mountTableRow(rowData);
            },
            OnClickFirstPage: function () {
                self.fetchPatientsList();
            },
            OnClickLastPage: function () {
                self.fetchPatientsList();
            },
            OnTableRendered: function () {
                window.reloadIconss();
            }
        });

        let urlParams = new URLSearchParams(window.location.search);
        let patientId = urlParams.get('patient_id');
        let branchId = urlParams.get('branch');
        if (patientId == null || branchId == null) {
            this.fetchPatientsList();
        }
        this.bindDomEvents();
        this.bindDomTableEvents();
        this.bindQueryParams();

        if (document.referrer) {
            $('.js-patients-registrations-go-back-button').removeClass('d-none');
            $('.js-patients-registrations-go-back-button').on('click', function () {
                window.location.href = document.referrer;
            });
        }

        return this;
    }

    bindDomEvents() {
        let self = this;

        var selectedComissionCCorrente = {
            serviceId: -1,
            quantity: 1,
            servicePrice: 0,
            discount: 0,
            unitPrice: 0,
            total: 0
        };

        // Detecta clique para editar Comissão do Doutor em um Conta Corrente
        $(document).on('click', '.js-patient-current-account-edit-doctor-comission', function () {
            let currentAccountInfo = $(this).data('info');
            //console.log('currentAccountInfo', 'edit-doctor-comission', currentAccountInfo);
            currentAccountUpdateInfo = currentAccountInfo;
            $("#modal-current-account-comission-transaction").modal('show');
            $(".js-current-account-comission-transaction-dialog-title-id").val(currentAccountInfo.ID);
            $("#edit_current_account_comission_service").val(currentAccountInfo.SERVICOS_ID);
            $("#edit_current_account_comission_transaction_service_amount").val(currentAccountInfo.QT_SERVICO);
            $("#edit_current_account_comission_transaction_service_price").val(currentAccountInfo.VALOR_SERVICO);
            $("#edit_current_account_comission_transaction_service_discount").val(currentAccountInfo.VALOR_DESCONTO);
            $("#edit_current_account_comission_transaction_service_unit_price").val(currentAccountInfo.VALOR_UNITARIO);
            $("#edit_current_account_comission_transaction_service_total_price").val(currentAccountInfo.VALOR_TOTAL);

            selectedComissionCCorrente = {
                serviceId: parseInt(currentAccountInfo.SERVICOS_ID),
                quantity: parseInt(currentAccountInfo.QT_SERVICO),
                servicePrice: parseFloat(currentAccountInfo.VALOR_SERVICO).toFixed(2),
                discount: parseFloat(currentAccountInfo.VALOR_DESCONTO).toFixed(2),
                unitPrice: parseFloat(currentAccountInfo.VALOR_UNITARIO).toFixed(2),
                total: parseFloat(currentAccountInfo.VALOR_TOTAL).toFixed(2)
            };
        });
        // Detecta clique para excluir Conta Corrente
        $(document).on('click', '.js-patient-current-account-delete', function () {
            let currentAccountInfo = $(this).data('info');
            //console.log('currentAccountInfo', 'delete', currentAccountInfo);
            currentAccountUpdateInfo = currentAccountInfo;
        });

        // Detecta envio do formulário de "Edição de Comissão do Doutor em uma Conta Corrente"
        $(document).on('submit', '.js-current-account-comission-transaction-form', function (e) {
            e.preventDefault();

            let serializeData = $(this).serializeArray();

            serializeData.push({
                name: 'edit_current_account_comission_old_data',
                value: currentAccountUpdateInfo
            })

            $(".modal-current-account-comission-transaction-dialog").block(window._loader.loading);

            let selfBtn = this;
            $(selfBtn).find('button[type="submit"]').prop('disabled', true);

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/patient/current_account_edit_comission',
                data: serializeData,
                successCallback: function (res) {
                    $(".modal-current-account-comission-transaction-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);

                    window.toast({
                        error: res.error,
                        text: res.message
                    })

                    if (!res.error) {
                        $('.js-current-account-comission-transaction-form').trigger('reset');
                        $('#modal-current-account-comission-transaction').modal('hide');
                        self.fetchPatientCurrentAccountData();
                    }
                },
                errorCallback: function (err) {
                    $(".modal-current-account-comission-transaction-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                }
            });
        });

        $(document).on('change', '#edit_current_account_comission_service', function () {
            let serviceInfo = $('#edit_current_account_comission_service option:selected').data('info');
            //console.log('serviceInfo', serviceInfo);
            selectedComissionCCorrente.serviceId = parseInt(serviceInfo.ID);
            selectedComissionCCorrente.quantity = 1;
            selectedComissionCCorrente.servicePrice = parseFloat(serviceInfo.VALOR).toFixed(2);
            selectedComissionCCorrente.discount = 0;
            selectedComissionCCorrente.unitPrice = parseFloat(selectedComissionCCorrente.servicePrice - (selectedComissionCCorrente.discount / selectedComissionCCorrente.quantity)).toFixed(2);
            selectedComissionCCorrente.total = parseFloat((selectedComissionCCorrente.unitPrice * selectedComissionCCorrente.quantity)).toFixed(2);

            $("#edit_current_account_comission_transaction_service_amount").val(selectedComissionCCorrente.quantity);
            $("#edit_current_account_comission_transaction_service_price").val(selectedComissionCCorrente.servicePrice);
            $("#edit_current_account_comission_transaction_service_discount").val(selectedComissionCCorrente.discount);
            $("#edit_current_account_comission_transaction_service_unit_price").val(selectedComissionCCorrente.unitPrice);
            $("#edit_current_account_comission_transaction_service_total_price").val(selectedComissionCCorrente.total);
        });

        $(document).on('change', '#edit_current_account_comission_transaction_service_amount', function () {
            let quantityValue = parseInt($(this).val());
            //console.log('quantityValue', quantityValue);
            selectedComissionCCorrente.quantity = quantityValue;
            selectedComissionCCorrente.unitPrice = parseFloat(selectedComissionCCorrente.servicePrice - (selectedComissionCCorrente.discount / selectedComissionCCorrente.quantity)).toFixed(2);
            selectedComissionCCorrente.total = parseFloat((selectedComissionCCorrente.unitPrice * selectedComissionCCorrente.quantity)).toFixed(2);

            $("#edit_current_account_comission_transaction_service_unit_price").val(selectedComissionCCorrente.unitPrice);
            $("#edit_current_account_comission_transaction_service_total_price").val(selectedComissionCCorrente.total);
        });

        $(document).on('change', '#edit_current_account_comission_transaction_service_discount', function () {
            let discountValue = $(this).val();
            //console.log('discountValue', discountValue);
            selectedComissionCCorrente.discount = parseFloat(discountValue).toFixed(2);
            selectedComissionCCorrente.unitPrice = parseFloat(selectedComissionCCorrente.servicePrice - (selectedComissionCCorrente.discount / selectedComissionCCorrente.quantity)).toFixed(2);
            selectedComissionCCorrente.total = parseFloat((selectedComissionCCorrente.unitPrice * selectedComissionCCorrente.quantity)).toFixed(2);

            $("#edit_current_account_comission_transaction_service_unit_price").val(selectedComissionCCorrente.unitPrice);
            $("#edit_current_account_comission_transaction_service_total_price").val(selectedComissionCCorrente.total);
        });

        $(".js-patients-registrations-filter-form").on('submit', (e) => {
            e.preventDefault();
        });

        // Detecta usuário mudando de filial para buscar paciente
        $('.js-patients-registrations-branches-selector').change(function () {
            self.selectedBranch = $(this).val();
            // Caso tenha selecinado uma filial, mostra o campo para buscar pelo nome do paciente
            if (self.selectedBranch != '') {
                /*$('.js-patients-registrations-container').html(`
                    <div class="col-12 mb-3">
                        <div class="form-group">
                            <label for="patients_registration_search">Agora busque pelo nome, telefone ou email do paciente:</label>
                            <select class="w-100 form-control" id="patients_registration_search" name="patients_registration_search"></select>
                        </div>
                    </div>
                `);*/

                if (self.isLoadingQuerySearch) {
                    self.isLoadingQuerySearch = false;
                    //$(".js-patients-registrations-container").block(window._loader.loading);
                }
                self.fetchPatientsList();
            } else {
                self.selectedBranch = -1;
                selectedPatient = false;
            }
        });

        // Detecta usuário buscando pelo nome do paciente
        $('#js-patients-registrations-search-input').on('input', function () {
            let urlParams = new URLSearchParams(window.location.search);
            let patientId = urlParams.get('patient_id');

            // make a typing debounce
            clearTimeout(self.searchQueryTimeout);
            self.searchQueryTimeout = setTimeout(function () {
                self.searchQuery = $('#js-patients-registrations-search-input').val().trim();
                if (patientId == self.searchQuery || self.searchQuery.length > 3) {
                    self.fetchPatientsList();
                } else if (self.searchQuery.length == 0) {
                    self.searchQuery = '';
                    self.fetchPatientsList();
                }
            }, 500);
        })

        // Detecta clique para abrir registro do cadastro do paciente
        $(document).on('click', '.js-patient-view-registry', function () {
            $('#modal-edit-patient').modal('show');
            $('.js-edit-patient-postal-code-error').addClass('d-none');

            selectedPatient = $(this).data('patient-info');
            //console.log('selectedPatient', selectedPatient)
            $("#edit_patient_branch").val(selectedPatient.FILIAL_ID);

            $("#edit_patient_doc_type").val(selectedPatient.TIPO_DOCUMENTO);
            if (selectedPatient.TIPO_DOCUMENTO == 'cpf') {
                $("label[for='edit_patient_document']").html('CPF <span class="req">*</span>');
                $('#edit_patient_document').val(selectedPatient.CPF);
                $('#edit_patient_document').mask('999.999.999-99', {
                    onComplete: function (txt) { self.onFillDocument(txt) }
                });
            } else {
                $("label[for='edit_patient_document']").html('Passaporte <span class="req">*</span>');
                $('#edit_patient_document').val(selectedPatient.PASSAPORTE);
                $('#edit_patient_document').mask('AAAAAAAAA', {
                    translation: {
                        'A': {
                            pattern: /[A-Z0-9]/
                        }
                    },
                    onComplete: function (txt) { self.onFillDocument(txt) }
                });
            }

            $('#edit_patient_birthday').val(selectedPatient.DATA_NASCIMENTO);
            $('#edit_patient_first_name').val(selectedPatient.PRIMEIRO_NOME);
            $('#edit_patient_sur_name').val(selectedPatient.SOBRENOME);
            $('#edit_patient_gender').val(selectedPatient.SEXO);
            $('#edit_patient_phone').val(selectedPatient.FONE_RESIDENCIAL);
            $('#edit_patient_cellphone').val(selectedPatient.FONE_CELULAR);
            $('#edit_patient_email').val(selectedPatient.EMAIL);
            $('#edit_patient_origin').val(selectedPatient.ORIGEM_ID);
            $('#edit_patient_profession').val(selectedPatient.PROFISSAO);

            $('#edit_patient_postal_code').val(selectedPatient.CEP);
            $('#edit_patient_address').val(selectedPatient.RUA);
            $('#edit_patient_address_number').val(selectedPatient.NUMERO);
            $('#edit_patient_address_complement').val(selectedPatient.COMPLEMENTO);
            $('#edit_patient_address_neighborhood').val(selectedPatient.BAIRRO);
            $('#edit_patient_address_city').val(selectedPatient.CIDADE);
            if (selectedPatient.ESTADO) {
                $('#edit_patient_address_state').val(selectedPatient.ESTADO);
            }
            if (selectedPatient.PAIS) {
                $('#edit_patient_address_country').val(selectedPatient.PAIS);
            }

            $('#edit_patient_frequency').val(selectedPatient.PERIODICIDADE);
            $('#edit_patient_observation').html(selectedPatient.OBS);
            $('#edit_patient_active').val(selectedPatient.ATIVO);

            window.reloadMasks();
        });

        $(document).on('click', '#edit_patient_address_number_checkbox', function () {
            if ($(this).is(':checked')) {
                $('#edit_patient_address_number').val('S/N');
                $('#edit_patient_address_number').attr('readonly', true);
            } else {
                $('#edit_patient_address_number').val('');
                $('#edit_patient_address_number').attr('readonly', false);
            }
        });



        // Detecta clique para abrir visualização de atendimentos do paciente
        $(document).on('click', '.js-patient-view-anamese', function (e) {
            e.preventDefault();
            let patientInfo = $(this).data('patient-info');
            console.log('patientInfo', patientInfo);
            self.fetchPatientAnamese(patientInfo);
        });

        // Detecta clique para abrir visualização de vendas do paciente
        $(document).on('click', '.js-patient-view-sales', function (e) {
            e.preventDefault();
            let patientInfo = $(this).data('patient-info');
            console.log('patientInfo', patientInfo);
            self.fetchPatientSales(patientInfo);
        });

        // Detecta clique para solicitar cortesia
        $(document).on('click', '.js-patient-request-courtesy', function () {
            let patientInfo = $(this).data('patient-info');
            console.log('patientInfo', patientInfo);
            self.requestCourtesyPatientId = patientInfo.ID;
            $('#modal-patient-request-courtesy').modal('show');

            $('.js-patient-request-courtesy-form').trigger('reset');
            $('#patient_request_courtesy_date').prop('disabled', true);
            $('#patient_request_courtesy_description').prop('disabled', true);
            $('.js-patient-request-courtesy-form').find('button[type="submit"]').prop('disabled', true);

            $('.js-business-services-or-plans-selector').html('');
        });

        // Detecta clique no radio de sessão individual/avaliação ou contrato
        $(document).on('click', 'input[name="js-patient-request-courtesy-is-individual-session-or-courtesy"]', function () {
            $('.js-business-services-or-plans-selector').html('');
            if ($(this).val() == 'S') {
                let html = '<option selected default value="">-- Selecione uma opção --</option>';
                for (let i in self.operatorAllowedServices) {
                    let serviceObj = self.operatorAllowedServices[i];
                    if (serviceObj.SERVICO.toLowerCase().indexOf('cortesia') == -1)
                        continue;
                    html += `
                        <option value="${serviceObj.ID}" data-service-time="${serviceObj.TEMPO_MINIMO}" data-info='${JSON.stringify(serviceObj)}'>${serviceObj.SERVICO}</option>
                    `;
                }
                $('.js-business-services-or-plans-selector').html(html);
            } else {
                // Resgata lista de planos
                if (!self.businessPlans) {
                    apiCall({
                        method: 'GET',
                        endpoint: 'api/v1/business/plans',
                        successCallback: function (res) {
                            if (!res.error) {
                                self.businessPlans = res.data;
                                let html = '<option selected default value="">-- Selecione --</option>';
                                for (let i = 0; i < res.data.length; i++) {
                                    let plan = res.data[i];
                                    if (plan.VISIVEL == 0 || plan.TOTAL_PLANO > 1) continue;
                                    html += `<option value='${plan.ID}' data-plan-info='${JSON.stringify(plan)}'>${plan.DESCRICAO}</option>`;
                                }
                                $('.js-business-services-or-plans-selector').html(html);
                            }
                        },
                        errorCallback: function (err) {
                        }
                    });
                } else {
                    let html = '<option selected default value="">-- Selecione --</option>';
                    for (let i = 0; i < self.businessPlans.length; i++) {
                        let plan = self.businessPlans[i];
                        if (plan.VISIVEL == 0 || plan.TOTAL_PLANO > 1) continue;
                        html += `<option value='${plan.ID}' data-plan-info='${JSON.stringify(plan)}'>${plan.DESCRICAO}</option>`;
                    }
                    $('.js-business-services-or-plans-selector').html(html);
                }
            }
            $('#patient_request_courtesy_date').prop('disabled', true);
            $('#patient_request_courtesy_description').prop('disabled', true);
            $('.js-patient-request-courtesy-form').find('button[type="submit"]').prop('disabled', true);
        });

        // Detecta mudança no serviço/plano selecionado
        $(document).on('change', '#patient_request_courtesy_service_or_plan_id', function () {
            if ($(this).val() != '') {
                $('#patient_request_courtesy_date').prop('disabled', false);
                $('#patient_request_courtesy_description').prop('disabled', false);
                $('.js-patient-request-courtesy-form').find('button[type="submit"]').prop('disabled', false);
            } else {
                $('#patient_request_courtesy_date').prop('disabled', true);
                $('#patient_request_courtesy_description').prop('disabled', true);
                $('.js-patient-request-courtesy-form').find('button[type="submit"]').prop('disabled', true);
            }
        });

        // Detecta envio do formulário de solicitação de cortesia
        $(document).on('submit', '.js-patient-request-courtesy-form', function (e) {
            e.preventDefault();

            let selfForm = this;
            $(selfForm).find('button[type="submit"]').prop('disabled', true);

            Swal.fire({
                title: 'Confirmação',
                text: 'Deseja realmente solicitar cortesia para este paciente?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    let formData = $(selfForm).serializeArray();
                    formData.push({
                        name: 'patient_request_courtesy_patient_id',
                        value: self.requestCourtesyPatientId
                    });
                    formData.push({
                        name: 'patient_request_courtesy_is_individual_session_or_courtesy',
                        value: $('input[name="js-patient-request-courtesy-is-individual-session-or-courtesy"]:checked').val()
                    });
                    console.log('formData', formData);

                    $(".modal-patient-request-courtesy-dialog").block(window._loader.loading);

                    apiCall({
                        method: 'POST',
                        endpoint: 'api/v1/patient/request_courtesy',
                        data: formData,
                        successCallback: function (res) {
                            window.toast({
                                error: res.error,
                                text: res.message
                            })

                            if (!res.error) {
                                $('.js-patient-request-courtesy-form').trigger('reset');
                                $('#modal-patient-request-courtesy').modal('hide');

                                Swal.fire({
                                    title: 'Sucesso',
                                    text: res.message,
                                    icon: 'success'
                                });
                            }
                            $(".modal-patient-request-courtesy-dialog").unblock();
                            $(selfForm).find('button[type="submit"]').prop('disabled', false);
                        },
                        errorCallback: function (err) {
                            $(".modal-patient-request-courtesy-dialog").unblock();
                            $(selfForm).find('button[type="submit"]').prop('disabled', false);
                        }
                    });
                } else {
                    $(selfForm).find('button[type="submit"]').prop('disabled', false);
                }
            });
        });

        // Detecta clique para abrir timeline do paciente
        $(document).on('click', '.js-patient-view-timeline', function () {
            let patientInfo = $(this).data('patient-info');
            console.log('patientInfo', patientInfo);

            selectedPatient = patientInfo;

            $(".js-patient-view-timeline-dialog-body").html(`
                <div class="d-flex justify-content-center">
                    <h6 class="text-primary">Carregando contratos...</h6>
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Carregando...</span>
                    </div>
                </div>
            `);

            let patientContracts = [];

            apiCall({
                method: 'GET',
                endpoint: 'api/v1/contracts',
                data: {
                    search: selectedPatient.CPF || selectedPatient.PASSAPORTE,
                    page: 1,
                    recordsPerPage: 1000,
                },
                successCallback: function (body) {
                    console.log('get body', body.data);
                    if (!body.error) {
                        patientContracts = body.data;
                    } else {
                        window.toast({
                            error: body.error,
                            text: body.message
                        })
                    }

                    $(".js-patient-view-timeline-dialog-body").html(`
                        <div class="d-flex justify-content-center">
                            <h6 class="text-primary">Carregando conta corrente...</h6>
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Carregando...</span>
                            </div>
                        </div>
                    `);

                    self.fetchPatientCurrentAccountData(patientInfo.FILIAL_ID, function (res) {

                        $('#js-patient-view-timeline-dialog-title-id').html(`Ficha do Paciente #${selectedPatient.ID} - ${selectedPatient.NOME_COMPLETO}`);

                        let htmlInsrt = '';

                        // Construir containers por aba
                        let contractsHtml = '';
                        let sessionsHtml = '';
                        let statusHtml = '';
                        let nonCompletedContractsHtml = '';

                        let totalPagoContratosCompletos = 0;
                        let totalPagoContratosIncompletos = 0;
                        let totalPagoSessoesIndividuais = 0;

                        if (res.error) {
                            window.toast({
                                error: true,
                                text: res.message
                            })

                            htmlInsrt = `<div class="alert alert-danger">${res.message}</div>`;
                        } else {
                            // reorganize by DATA (desc)
                            let data = res.data.sort((a, b) => new Date(b.DATA) - new Date(a.DATA));

                            // Agrupar por contrato
                            let contratos = {};
                            let sessoesIndividuais = [];
                            let countContratos = 0;
                            let countSessoes = 0;

                            //console.log('patientContracts', patientContracts);

                            contractsHtml = `<div class="row g-3">
                                <div class="col-12 mb-3">
                                    <h6 class="text-dark">Contratos</h6>
                                    <div id="js-contracts-total-value" class="text-dark">R$ 0,00</div>
                                </div>
                            </div>`;

                            statusHtml = `<div class="row g-3">
                                <div class="col-12 mb-3">
                                    <h6 class="text-dark">Contratos finalizados</h6>
                                    <div id="js-completed-contracts-total-value" class="text-dark">R$ 0,00</div>
                                </div>
                            </div>`;

                            nonCompletedContractsHtml = `<div class="row g-3">
                                <div class="col-12 mb-3">
                                    <h6 class="text-dark">Contratos em andamento</h6>
                                    <div id="js-non-completed-contracts-total-value" class="text-dark">R$ 0,00</div>
                                </div>
                            </div>`;

                            sessionsHtml = `<div class="row g-3">
                                <div class="col-12 mb-3">
                                    <h6 class="text-dark">Sessões individuais</h6>
                                    <div id="js-sessions-individual-total-value" class="text-dark">R$ 0,00</div>
                                </div>
                            </div>`;

                            data.forEach(item => {
                                if (item.CONTRATO_ID && item.CONTRATO_ID != 0) {
                                    if (!contratos[item.CONTRATO_ID]) {
                                        contratos[item.CONTRATO_ID] = {
                                            contrato: item,
                                            sessoes: []
                                        };
                                        countContratos++;
                                    }
                                    contratos[item.CONTRATO_ID].sessoes.push(item);
                                    countSessoes++;
                                } else {
                                    sessoesIndividuais.push(item);
                                    countSessoes++;
                                }
                            });

                            // order contract sessoes by session PARCELA
                            Object.keys(contratos).forEach(contratoId => {
                                contratos[contratoId].sessoes.sort((a, b) => a.PARCELA - b.PARCELA);
                            });


                            // Adicionar CSS para o timeline e cabeçalho estilo "perfil"
                            htmlInsrt += `
                                <style>
                                .patient-timeline { position: relative; padding: 20px 0; }
                                .timeline-contract-group { margin-bottom: 30px; border-left: 4px solid #007bff; padding-left: 20px; position: relative; }
                                .timeline-individual-group { margin-bottom: 20px; border-left: 4px solid #28a745; padding-left: 20px; position: relative; }
                                .timeline-contract-header { background: linear-gradient(135deg, #007bff, #0056b3); color: white; padding: 15px 20px; border-radius: 10px; margin-bottom: 15px; box-shadow: 0 4px 15px rgba(0,123,255,0.3); }
                                .timeline-individual-header { background: linear-gradient(135deg, #28a745, #1e7e34); color: white; padding: 12px 20px; border-radius: 8px; margin-bottom: 10px; box-shadow: 0 4px 15px rgba(40,167,69,0.3); }
                                .timeline-session-card { background: white; border: 1px solid #e9ecef; border-radius: 8px; padding: 15px; margin-bottom: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); transition: all 0.3s ease; }
                                .timeline-session-card:hover { box-shadow: 0 4px 15px rgba(0,0,0,0.15); transform: translateY(-2px); }
                                .session-date { font-weight: 600; color: #495057; font-size: 14px; margin-bottom: 8px; }
                                .session-info { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
                                .session-service { font-weight: 500; color: #212529; }
                                .session-doctor { color: #6c757d; font-size: 13px; }
                                .session-financial { display: flex; gap: 15px; margin-top: 10px; padding-top: 10px; border-top: 1px solid #e9ecef; }
                                .financial-item { text-align: center; flex: 1; }
                                .financial-label { font-size: 11px; color: #6c757d; text-transform: uppercase; margin-bottom: 2px; }
                                .financial-value { font-weight: 600; color: #212529; }
                                .financial-value.positive { color: #28a745; }
                                .financial-value.negative { color: #dc3545; }
                                .contract-summary { background: #f8f9fa; padding: 10px 15px; border-radius: 6px; margin-top: 10px; display: flex; justify-content: space-between; align-items: center; }
                                .contract-progress { display: flex; align-items: center; gap: 10px; }
                                .progress-bar-custom { width: 100px; height: 8px; background: #e9ecef; border-radius: 4px; overflow: hidden; }
                                .progress-fill { height: 100%; background: linear-gradient(90deg, #28a745, #20c997); transition: width 0.3s ease; }
                                .timeline-dot { position: absolute; left: -8px; top: 20px; width: 16px; height: 16px; border-radius: 50%; background: #007bff; border: 3px solid white; box-shadow: 0 2px 8px rgba(0,0,0,0.2); }
                                .timeline-dot.individual { background: #28a745; }
                                /* Cabeçalho estilo perfil */
                                .patient-profile-cover { height: 140px; border-radius: 8px; background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%); position: relative; z-index: 1; }
                                .patient-profile { margin-top: -32px; display: flex; align-items: end; gap: 16px; position: relative; z-index: 2; }
                                .patient-avatar { width: 96px; height: 96px; border-radius: 50%; border: 4px solid #fff; background: #e9ecef; display: flex; align-items: center; justify-content: center; font-size: 36px; color: #6c757d; }
                                .patient-meta h4 { margin: 0; }
                                .patient-meta .small { color: #6c757d; }
                                .patient-actions { margin-left: auto; }
                                /* Contrato colapsável */
                                .timeline-contract-header { cursor: pointer; transition: all 0.3s ease; }
                                .timeline-contract-header:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(0,123,255,0.4); }
                                .timeline-contract-header .contract-toggle-icon { transition: transform 0.3s ease; }
                                .timeline-contract-header.collapsed .contract-toggle-icon { transform: rotate(-90deg); }
                                .timeline-contract-sessions { transition: all 0.3s ease; overflow: hidden; }
                                .timeline-contract-sessions.collapsed { max-height: 0; opacity: 0; margin: 0; }
                                .timeline-contract-sessions.expanded { max-height: 2000px; opacity: 1; }
                                </style>
                            `;

                            // Cabeçalho perfil
                            htmlInsrt += `
                                <div class="patient-profile-cover"></div>
                                <div class="patient-profile">
                                    <div class="patient-avatar"><i class="fas fa-user"></i></div>
                                    <div class="patient-meta">
                                        <h4 class="text-dark">${selectedPatient.NOME_COMPLETO ?? 'Paciente'}</h4>
                                        <div class="small">ID ${selectedPatient.ID} • ${selectedPatient.EMAIL || ''} • ${selectedPatient.FONE_CELULAR || ''}</div>
                                    </div>
                                    <div class="patient-actions">
                                        <span class="badge ${selectedPatient.ATIVO === 'S' ? 'bg-success' : 'bg-secondary'}">${selectedPatient.ATIVO === 'S' ? 'Ativo' : 'Inativo'}</span>
                                    </div>
                                </div>
                                <ul class="nav nav-tabs mt-4" id="patientTimelineTabs" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link active" id="tab-overview-tab" data-bs-toggle="tab" data-bs-target="#tab-overview" type="button" role="tab">Visão geral</button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" id="tab-contracts-tab" data-bs-toggle="tab" data-bs-target="#tab-contracts" type="button" role="tab">Todos contratos</button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" id="tab-status-tab" data-bs-toggle="tab" data-bs-target="#tab-status" type="button" role="tab">Contratos finalizados</button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" id="tab-non-completed-contracts-tab" data-bs-toggle="tab" data-bs-target="#tab-non-completed-contracts" type="button" role="tab">Contratos em andamento</button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" id="tab-sessions-tab" data-bs-toggle="tab" data-bs-target="#tab-sessions" type="button" role="tab">Sessões individuais</button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link js-patient-view-anamese" data-patient-info='${JSON.stringify(patientInfo)}' id="tab-atendimentos-tab" href="#">Atendimentos</a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link js-patient-view-sales" data-patient-info='${JSON.stringify(patientInfo)}' id="tab-financeiro-tab" data-bs-toggle="tab" data-bs-target="#tab-financeiro" type="button" role="tab">Financeiro</button>
                                    </li>
                                </ul>
                                <div class="tab-content pt-3" id="patientTimelineTabsContent">
                                    <div class="tab-pane fade show active" id="tab-overview" role="tabpanel">
                                        <div class="container">
                                            <div class="row g-3">
                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">Total de contratos</div>
                                                        <div class="h5 mb-0 text-dark">${countContratos}</div>
                                                    </div><i class="fas fa-file-alt fs-3 text-primary"></i></div></div></div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">Sessões (todas)</div>
                                                        <div class="h5 mb-0 text-dark">${countSessoes}</div>
                                                    </div><i class="fas fa-calendar-alt fs-3 text-success"></i></div></div></div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">Contratos completos</div>
                                                        <div class="h5 mb-0 text-dark" id="js-contracts-completed-counter">0</div>
                                                    </div><i class="fas fa-check-circle fs-3 text-info"></i></div></div></div>
                                                </div>
                                            </div>
                                            <div class="row g-3 mt-3">
                                                <div class="col-12">
                                                    <h6 class="text-dark">Dados Pessoais do paciente</h6>
                                                </div>

                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">Nome</div>
                                                        <div class="h5 mb-0 text-dark">${selectedPatient.NOME_COMPLETO}</div>
                                                    </div><i class="fas fa-user fs-3 text-primary"></i></div></div></div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">Email</div>
                                                        <div class="h5 mb-0 text-dark">${selectedPatient.EMAIL}</div>
                                                    </div><i class="fas fa-envelope fs-3 text-primary"></i></div></div></div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">Telefone</div>
                                                        <div class="h5 mb-0 text-dark">${selectedPatient.FONE_CELULAR}</div>
                                                    </div><i class="fas fa-phone fs-3 text-primary"></i></div></div></div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">CPF</div>
                                                        <div class="h5 mb-0 text-dark">${selectedPatient.TEM_CPF == 'S' ? selectedPatient.CPF : selectedPatient.PASSAPORTE}</div>
                                                    </div><i class="fas fa-id-card fs-3 text-primary"></i></div></div></div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">Data de nascimento</div>
                                                        <div class="h5 mb-0 text-dark">${selectedPatient.DATA_NASCIMENTO_FORMATTED}</div>
                                                    </div><i class="fas fa-calendar-alt fs-3 text-primary"></i></div></div></div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">Sexo</div>
                                                        <div class="h5 mb-0 text-dark">${selectedPatient.SEXO}</div>
                                                    </div><i class="fas fa-genderless fs-3 text-primary"></i></div></div></div>
                                                </div>
                                                
                                                <div class="col-12 mt-3">
                                                    <h6 class="text-dark">Dados do endereço do paciente</h6>
                                                </div>

                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">CEP</div>
                                                        <div class="h5 mb-0 text-dark">${selectedPatient.CEP}</div>
                                                    </div><i class="fas fa-map-marker-alt fs-3 text-primary"></i></div></div></div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">Rua</div>
                                                        <div class="h5 mb-0 text-dark">${selectedPatient.RUA}</div>
                                                    </div><i class="fas fa-map-marker-alt fs-3 text-primary"></i></div></div></div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">Número</div>
                                                        <div class="h5 mb-0 text-dark">${selectedPatient.NUMERO}</div>
                                                    </div><i class="fas fa-map-marker-alt fs-3 text-primary"></i></div></div></div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">Complemento</div>
                                                        <div class="h5 mb-0 text-dark">${selectedPatient.COMPLEMENTO}</div>
                                                    </div><i class="fas fa-map-marker-alt fs-3 text-primary"></i></div></div></div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">Bairro</div>
                                                        <div class="h5 mb-0 text-dark">${selectedPatient.BAIRRO}</div>
                                                    </div><i class="fas fa-map-marker-alt fs-3 text-primary"></i></div></div></div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">Cidade</div>
                                                        <div class="h5 mb-0 text-dark">${selectedPatient.CIDADE}</div>
                                                    </div><i class="fas fa-map-marker-alt fs-3 text-primary"></i></div></div></div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">Estado</div>
                                                        <div class="h5 mb-0 text-dark">${selectedPatient.ESTADO}</div>
                                                    </div><i class="fas fa-map-marker-alt fs-3 text-primary"></i></div></div></div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                                        <div class="text-muted small">País</div>
                                                        <div class="h5 mb-0 text-dark">${selectedPatient.PAIS}</div>
                                                    </div><i class="fas fa-map-marker-alt fs-3 text-primary"></i></div></div></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="tab-contracts" role="tabpanel">
                                        <div class="container">
                                            <div class="patient-timeline" id="contractsTimeline">
                                                <!-- contratos aqui -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="tab-status" role="tabpanel">
                                        <div class="container">
                                            <div class="patient-timeline" id="statusTimeline"></div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="tab-non-completed-contracts" role="tabpanel">
                                        <div class="container">
                                            <div class="patient-timeline" id="nonCompletedContractsTimeline"></div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="tab-sessions" role="tabpanel">
                                        <div class="container">
                                            <div class="patient-timeline" id="sessionsTimeline"></div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="tab-atendimentos" role="tabpanel">
                                        <div class="container">
                                            <div class="patient-timeline" id="atendimentosTimeline"></div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="tab-financeiro" role="tabpanel">
                                        <div class="patient-timeline" id="js-patient-sales-registrations-container"></div>
                                    </div>
                                </div>
                            `;

                            // Renderizar contratos ordenados por ID (maior para menor)
                            Object.keys(contratos).sort((a, b) => b - a).forEach(contratoId => {
                                let contratoData = contratos[contratoId];
                                let contrato = contratoData.contrato;
                                let sessoes = contratoData.sessoes;
                                let contratoRealData = patientContracts.find(contract => contract.ID == contratoId);

                                // Calcular progresso do contrato
                                let totalSessoes = parseInt(sessoes.length);
                                let sessoesRealizadas = sessoes.reduce((sum, sessao) => sum + (sessao.STATUS == 'A' ? 1 : 0), 0);
                                let progressoPercent = (sessoesRealizadas / totalSessoes) * 100;

                                //console.log('contratoId', contratoId, 'contrato', contrato);
                                //console.log('contratoId', contratoId, 'totalSessoes', totalSessoes);
                                //console.log('---------------------------------------------')

                                // Calcular valores totais
                                let valorTotal = sessoes.reduce((sum, sessao) => sum + parseFloat(sessao.VALOR_UNITARIO), 0);
                                let valorDesconto = sessoes.reduce((sum, sessao) => sum + parseFloat(sessao.VALOR_DESCONTO), 0);

                                contractsHtml += `
                                    <div class="timeline-contract-group">
                                        <div class="timeline-dot"></div>
                                        <div class="timeline-contract-header collapsed" data-contract-id="${contratoId}" onclick="toggleContractSessions(${contratoId})">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <h5 class="mb-1">
                                                        <i class="fas fa-chevron-down contract-toggle-icon me-2"></i>
                                                        Contrato ${contratoId}
                                                    </h5>
                                                    <p class="mb-0 text-light">${contrato.PLANO || 'Plano não especificado'}</p>
                                                    <p class="mb-0 text-light"><strong>Adesão:</strong> ${moment(contratoRealData.DATA_ADESAO_FORMATTED).tz("America/Sao_Paulo").format("DD/MM/YYYY")}</p>
                                                    <p class="mb-0 text-light"><strong>Encerramento:</strong> ${moment(contratoRealData.DATA_ENCERRAMENTO_FORMATTED).tz("America/Sao_Paulo").format("DD/MM/YYYY")}</p>
                                                </div>
                                                <div class="text-end">
                                                    <div class="contract-progress">
                                                        <span class="text-white-50">${sessoesRealizadas}/${totalSessoes}</span>
                                                        <div class="progress-bar-custom">
                                                            <div class="progress-fill" style="width: ${progressoPercent}%"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="mb-0 text-light"><strong>Status:</strong> ${contratoRealData.STATUS == 'A' ? 'Ativo' : 'Inativo'}</p>
                                            <p class="mb-0 text-light"><strong>Upload:</strong> ${contratoRealData.UPLOAD_CONTRATO == 'S' ? 'Sim' : 'Não'}</p>
                                            <p class="mb-0 text-light"><strong>Bloqueado:</strong> ${contratoRealData.BLOQUEADO == 'S' ? '<span class="badge bg-danger">Sim</span>' : 'Não'}</p>
                                            <p class="mb-0 text-light"><strong>Motivo de bloqueio:</strong> ${contratoRealData.BLOQUEADO == 'S' ? `<span class="badge bg-danger">${contratoRealData.OBS_BLOQUEIO}</span>` : 'Não bloqueado'}</p>
                                        </div>
                                        <div class="timeline-contract-sessions collapsed" id="contract-sessions-${contratoId}">
                                `;

                                sessoes.forEach(sessao => {
                                    let serviceName = '';
                                    for (let x = 0; x < self.operatorAllowedServices.length; x++) {
                                        let service = self.operatorAllowedServices[x];
                                        if (service.ID == sessao.SERVICOS_ID) {
                                            serviceName = service.SERVICO;
                                            break;
                                        }
                                    }

                                    contractsHtml += `
                                        <div class="timeline-session-card" data-contract-id="${contratoId}" data-session-id="${sessao.ID}">
                                            <div class="session-date">
                                                <i class="fas fa-calendar-alt me-2"></i>${sessao.DATA_ATENDIMENTO_FORMATTED ?? 'Sessão não realizada'}
                                            </div>
                                            <div class="session-info">
                                                <div>
                                                    <div class="session-service">${serviceName} (${sessao.PARCELA})</div>
                                                    <div class="session-doctor">
                                                        <i class="fas fa-user-md me-1"></i>${sessao.STAFF_NAME}
                                                    </div>
                                                </div>
                                                <div class="text-end">
                                                    <span class="badge ${sessao.TIPO_PACIENTE === 'PR' ? 'bg-primary' : 'bg-success'}">${serviceName}</span>
                                                </div>
                                            </div>
                                            <div class="session-financial">
                                                <div class="financial-item">
                                                    <div class="financial-label">Valor Unitário</div>
                                                    <div class="financial-value">R$ ${parseFloat(sessao.VALOR_UNITARIO).toFixed(2)}</div>
                                                </div>
                                                <div class="financial-item">
                                                    <div class="financial-label">Sessão</div>
                                                    <div class="financial-value">${sessao.PARCELA}</div>
                                                </div>
                                            </div>
                                        </div>
                                    `;
                                });

                                // Rodapé de cada contrato
                                contractsHtml += `
                                    </div>
                                    <div class="contract-summary d-none">
                                        <div>
                                            <strong>Resumo do Contrato:</strong>
                                            <span class="ms-2">${sessoesRealizadas} de ${totalSessoes} sessões realizadas</span>
                                        </div>
                                        <div class="text-end">
                                            <div class="financial-value positive">Total: R$ ${valorTotal.toFixed(2)}</div>
                                            ${valorDesconto > 0 ? `<div class="financial-value negative">Desconto: R$ ${valorDesconto.toFixed(2)}</div>` : ''}
                                        </div>
                                    </div>
                                </div>
                                `;

                                // Status por contrato
                                const completo = sessoesRealizadas >= totalSessoes && totalSessoes > 0;
                                if (completo) {
                                    totalPagoContratosCompletos += valorTotal;
                                    statusHtml += `
                                        <div class="timeline-session-card">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <strong class="text-dark">Contrato ${contratoId}</strong>
                                                    <div class="small text-muted">${contrato.PLANO || ''}</div>
                                                    <div class="small text-muted"><strong>Adesão:</strong> ${moment(contratoRealData.DATA_ADESAO_FORMATTED).tz("America/Sao_Paulo").format("DD/MM/YYYY")}</div>
                                                    <div class="small text-muted"><strong>Encerramento:</strong> ${moment(contratoRealData.DATA_ENCERRAMENTO_FORMATTED).tz("America/Sao_Paulo").format("DD/MM/YYYY")}</div>
                                                    <div class="small text-muted"><strong>Status:</strong> ${contratoRealData.STATUS == 'A' ? 'Ativo' : 'Inativo'}</div>
                                                    <div class="small text-muted"><strong>Upload:</strong> ${contratoRealData.UPLOAD_CONTRATO == 'S' ? 'Sim' : 'Não'}</div>
                                                    <div class="small text-muted"><strong>Bloqueado:</strong> ${contratoRealData.BLOQUEADO == 'S' ? '<span class="badge bg-danger">Sim</span>' : 'Não'}</div>
                                                    <div class="small text-muted"><strong>Motivo de bloqueio:</strong> ${contratoRealData.BLOQUEADO == 'S' ? `<span class="badge bg-danger">${contratoRealData.OBS_BLOQUEIO}</span>` : 'Não bloqueado'}</div>
                                                </div>
                                                <div class="text-end">
                                                    <span class="badge ${completo ? 'bg-success' : 'bg-warning text-dark'}">${completo ? 'Completo' : 'Em andamento'}</span>
                                                    <div class="small text-dark">${sessoesRealizadas}/${totalSessoes} sessões</div>
                                                </div>
                                            </div>
                                        </div>
                                    `;
                                } else {
                                    totalPagoContratosIncompletos += valorTotal;
                                    nonCompletedContractsHtml += `
                                        <div class="timeline-session-card">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <strong class="text-dark">Contrato ${contratoId}</strong>
                                                    <div class="small text-muted">${contrato.PLANO || ''}</div>
                                                    <div class="small text-muted"><strong>Adesão:</strong> ${moment(contratoRealData.DATA_ADESAO_FORMATTED).tz("America/Sao_Paulo").format("DD/MM/YYYY")}</div>
                                                    <div class="small text-muted"><strong>Encerramento:</strong> ${moment(contratoRealData.DATA_ENCERRAMENTO_FORMATTED).tz("America/Sao_Paulo").format("DD/MM/YYYY")}</div>
                                                    <div class="small text-muted"><strong>Status:</strong> ${contratoRealData.STATUS == 'A' ? 'Ativo' : 'Inativo'}</div>
                                                    <div class="small text-muted"><strong>Upload:</strong> ${contratoRealData.UPLOAD_CONTRATO == 'S' ? 'Sim' : 'Não'}</div>
                                                    <div class="small text-muted"><strong>Bloqueado:</strong> ${contratoRealData.BLOQUEADO == 'S' ? '<span class="badge bg-danger">Sim</span>' : 'Não'}</div>
                                                    <div class="small text-muted"><strong>Motivo de bloqueio:</strong> ${contratoRealData.BLOQUEADO == 'S' ? `<span class="badge bg-danger">${contratoRealData.OBS_BLOQUEIO}</span>` : 'Não bloqueado'}</div>
                                                </div>
                                                <div class="text-end">
                                                    <span class="badge bg-warning text-dark">Em andamento</span>
                                                    <div class="small text-dark">${sessoesRealizadas}/${totalSessoes} sessões</div>
                                                </div>
                                            </div>
                                        </div>
                                    `;
                                }
                            });

                            // Renderizar sessões individuais (aba Sessões)
                            if (sessoesIndividuais.length > 0) {
                                sessionsHtml += `
                                    <div class="timeline-individual-group">
                                        <div class="timeline-dot individual"></div>
                                        <div class="timeline-individual-header">
                                            <h5 class="mb-0">
                                                <i class="fas fa-user me-2"></i>Sessões Individuais
                                            </h5>
                                        </div>
                                `;

                                sessoesIndividuais.forEach(sessao => {
                                    let serviceName = '';
                                    for (let x = 0; x < self.operatorAllowedServices.length; x++) {
                                        let service = self.operatorAllowedServices[x];
                                        if (service.ID == sessao.SERVICOS_ID) {
                                            serviceName = service.SERVICO;
                                            break;
                                        }
                                    }

                                    totalPagoSessoesIndividuais += parseFloat(sessao.VALOR_UNITARIO);
                                    sessionsHtml += `
                                        <div class="timeline-session-card">
                                            <div class="session-date">
                                                <i class="fas fa-calendar-alt me-2"></i>${sessao.DATA_ATENDIMENTO_FORMATTED ?? 'Sessão não realizada'}
                                            </div>
                                            <div class="session-info">
                                                <div>
                                                    <div class="session-service">${serviceName}</div>
                                                    <div class="session-doctor">
                                                        <i class="fas fa-user-md me-1"></i>${sessao.STAFF_NAME}
                                                    </div>
                                                </div>
                                                <div class="text-end">
                                                    <span class="badge ${sessao.TIPO_PACIENTE === 'PR' ? 'bg-primary' : 'bg-success'}">${serviceName}</span>
                                                </div>
                                            </div>
                                            <div class="session-financial">
                                                <div class="financial-item">
                                                    <div class="financial-label">Valor Unitário</div>
                                                    <div class="financial-value">R$ ${parseFloat(sessao.VALOR_UNITARIO).toFixed(2)}</div>
                                                </div>
                                                <div class="financial-item">
                                                    <div class="financial-label">Sessão</div>
                                                    <div class="financial-value">${sessao.PARCELA}</div>
                                                </div>
                                            </div>
                                        </div>
                                    `;
                                });

                                sessionsHtml += `</div>`;
                            }
                        }

                        // Injetar conteúdos nas abas
                        setTimeout(function () {
                            const $dialog = $(".js-patient-view-timeline-dialog-body");
                            let totalPagoContratos = totalPagoContratosCompletos + totalPagoContratosIncompletos;
                            $dialog.html(htmlInsrt);
                            $("#contractsTimeline").html(contractsHtml);
                            $("#sessionsTimeline").html(sessionsHtml);
                            $("#statusTimeline").html(statusHtml);
                            $("#nonCompletedContractsTimeline").html(nonCompletedContractsHtml);
                            $("#js-contracts-total-value").html(`R$ ${totalPagoContratos.toFixed(2)}`);
                            $("#js-completed-contracts-total-value").html(`R$ ${totalPagoContratosCompletos.toFixed(2)}`);
                            $("#js-non-completed-contracts-total-value").html(`R$ ${totalPagoContratosIncompletos.toFixed(2)}`);
                            $("#js-sessions-individual-total-value").html(`R$ ${totalPagoSessoesIndividuais.toFixed(2)}`);
                            // Atualiza contador de completos
                            let completed = (statusHtml.match(/badge bg-success/g) || []).length;
                            $("#js-contracts-completed-counter").text(completed);
                        }, 0);
                    });
                },
                errorCallback: function (err) {
                    console.log('err', err);
                }
            });

            $('#modal-patient-view-timeline').modal('show');
        });

        $("#patientServiceModal .btn-primary").on("click", function () {
            let modalContent = $("#patientServiceModal .modal-body").html();

            let printWindow = window.open("", "_blank");
            printWindow.document.write(`
                <html>
                <head>
                    <title>Histórico de Atendimento</title>
                    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
                    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-icons/1.10.5/font/bootstrap-icons.min.css">
                    <style>
                    body { font-family: Arial, sans-serif; padding: 20px; }
                    .modal-body { padding: 20px; }
                    </style>
                </head>
                <body>
                    ${modalContent}
                    <script>
                    window.onload = function() {
                        window.print();
                        window.close();
                    };
                    <\/script>
                </body>
                </html>
            `);
            printWindow.document.close();
        });

        // Detecta clique para abrir registro de conta corrente do paciente
        $(document).on('click', '.js-patient-current-account-registry', function () {
            selectedPatient = $(this).data('patient-info');
            $("#modal-current-account-registry").modal('show');
            $('.js-patients-registrations-accordion-container').html(`<div class="accordion mb-3" id="accordionPatientsRegistrationsContracts">Sem conta corrente.</div>`);
            $(".js-current-account-registry-dialog-title-id").html(`${selectedPatient.ID}`);
            getBusinessDoctorsListByBranchId(selectedPatient.FILIAL_ID, function () {
                self.fetchPatientCurrentAccountData();
            });
        });

        // Detecta clique para abrir registro do cadastro do paciente
        $(document).on('click', '.js-current-account-add-transaction', function () {
            selectedPatient = $(this).data('patient-info');
            $('#modal-current-account-add-transaction').modal('show');
            $('.js-current-account-add-transaction-form').trigger('reset');
            $("#edit_current_account_transaction_hunter").val(userHasRole('HUNTER') ? window._sessionData.userId : 'Clinica');
            $(".js-current-account-add-transaction-dialog-title-id").html(`${selectedPatient.ID}`);

            if (selectedPatient.CONTA_CORRENTE == 'N' && selectedPatient.CADASTRO_COMPLETO == 'S') {
                $('#edit_current_account_transaction_patient_type').val('1');
            }

            if ($(this).hasClass('js-edit-agenda-customer-current-account-launch')) {

            }
            getBusinessDoctorsListByBranchId(selectedPatient.FILIAL_ID, function () {
            });

            /*$("#edit_current_account_transaction_agenda_id").html(`<option value="">CARREGANDO AGENDAS...</option>`);
            apiCall({
                method: 'GET',
                endpoint: 'api/v1/patient/schedules',
                data: {
                    patientId: selectedPatient.ID,
                    branchId: selectedPatient.FILIAL_ID
                },
                successCallback: function(res) {
                    console.log('crud_patients_registrations.js/patient/schedules', 'fetchPatientCurrentAccountData', res);
                    if (res.error) {
                        window.toast({
                            error: true,
                            text: res.message
                        })
                    } else {
                        let html = '<option value="">-- Deixe em branco caso não tenha agendamento --</option>';
                        for(let i in res.data) {
                            let schedule = res.data[i];
                            html += `
                                <option value="${schedule.ID}">${schedule.DATA_INICIO_FORMATTED} - ${schedule.STAFF_NAME}</option>
                            `;
                        }
                        $('#edit_current_account_transaction_agenda_id').html(html);
                    }
                },
                errorCallback: function(err) {
                    window.toast({
                        error: true,
                        text: 'Erro ao carregar agendas do paciente.'
                    })
                }
            })*/

            window.reloadMasks();
        });

        // Detecta alteração do tipo de documento
        $(document).on('change', '#edit_patient_doc_type', function () {
            let getDocType = $(this).val();
            if (getDocType === 'cpf') {
                $('.edit_patient_document').html(`CPF <span class="req">*</span>`);
                // Apply CPF input mask
                $('#edit_patient_document').mask('999.999.999-99', {
                    onComplete: function (txt) { self.onFillDocument(txt) }
                });
            } else {
                $('.edit_patient_document').html(`Passaporte <span class="req">*</span>`);
                // Apply Passport input mask
                $('#edit_patient_document').mask('AAAAAAAAA', {
                    translation: {
                        'A': {
                            pattern: /[A-Z0-9]/
                        }
                    },
                    onComplete: function (txt) { self.onFillDocument(txt) }
                });
            }
        });

        // Detecta envio do formulário de edição de cadastro
        $(document).on('submit', '.js-patient-edit', function (e) {
            e.preventDefault();

            let serializeData = $('.js-patient-edit').serializeArray();

            $(".modal-edit-patient-dialog").block(window._loader.loading);

            serializeData.push({
                name: 'edit_patient_old_data',
                value: selectedPatient
            })

            let selfBtn = this;
            $(selfBtn).find('button[type="submit"]').prop('disabled', true);

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/patient/update',
                data: serializeData,
                successCallback: function (res) {
                    $(".modal-edit-patient-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);

                    window.toast({
                        error: res.error,
                        text: res.message
                    })

                    if (!res.error) {
                        // TODO: Recarregar dados do cliente para atualizar variaveis  do paciente selecionado, ou retornar aqui(?)
                        selectedPatient = res.data;
                        selectedPatient.TEXT = res.data.TEXT;
                        self.fetchPatientsList();
                        $("#modal-edit-patient").modal('hide')
                    }
                },
                errorCallback: function (err) {
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                    $(".modal-edit-patient-dialog").unblock();
                }
            });
        });

        // Detecta envio do formulário de inserção de conta corrente
        $(document).on('submit', '.js-current-account-add-transaction-form', function (e) {
            e.preventDefault();

            let serializeData = $(this).serializeArray();

            $(".modal-current-account-add-transaction-dialog").block(window._loader.loading);

            serializeData.push({
                name: 'edit_current_account_transaction_patient_old_data',
                value: selectedPatient
            })

            serializeData.push({
                name: 'edit_current_account_transaction_service_id',
                value: $('#edit_current_account_service').val()
            })

            let selfBtn = this;
            $(selfBtn).find('button[type="submit"]').prop('disabled', true);

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/patient/current_account_add_transaction',
                data: serializeData,
                successCallback: function (res) {
                    $(".modal-current-account-add-transaction-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);

                    window.toast({
                        error: res.error,
                        text: res.message
                    })

                    if (!res.error) {
                        $('.js-current-account-add-transaction-form').trigger('reset');
                        $("#edit_current_account_transaction_service_amount").val(1);
                        $('#modal-current-account-add-transaction').modal('hide');
                        self.fetchPatientsList();
                    }
                },
                errorCallback: function (err) {
                    $(".modal-current-account-add-transaction-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                }
            });
        });

        $(document).on('click', '.js-patient-sessions-toggler', function () {
            let patientId = $(this).data('patient-id');
            let branchId = $(this).data('branch-id');
            selectedPatient = {
                ID: patientId,
                FILIAL_ID: branchId
            }
            // open tr with sessions
            $(`.js-patient-sessions-${patientId}`).toggleClass('d-none');
            if ($(`.js-patient-sessions-${patientId}`).hasClass('d-none')) {
                $(`.js-patient-sessions-btn-${patientId}`).html(`<i class="fas fa-eye"></i> Ver contratos`);
                $(`js-patient-sessions-list-${patientId}`).html(`
                    <!-- spinner -->
                    <div class="d-flex justify-content-center">
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden">Carregando...</span>
                        </div>
                    </div>
                `);
            } else {
                self.fetchPatientCurrentAccountData();
                $(`.js-patient-sessions-btn-${patientId}`).html(`<i class="fas fa-eye-slash"></i> Esconder contratos`);
                $(`.js-patient-sessions-btn-${patientId}`).prop('disabled', true);
            }
        });

        $(document).on('click', '.js-patient-contract-sessions-toggler', function () {
            let contractId = $(this).data('contract-id');
            let branchId = $(this).data('branch-id');
            // open tr with sessions
            $(`.js-patient-contract-sessions-${contractId}`).toggleClass('d-none');
            if ($(`.js-patient-contract-sessions-${contractId}`).hasClass('d-none')) {
                $(`.js-patient-contract-sessions-btn-${contractId}`).html(`<i class="fas fa-eye"></i> Ver sessões`);
                $(`js-patient-contract-sessions-list-${contractId}`).html(`
                    <!-- spinner -->
                    <div class="d-flex justify-content-center">
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden">Carregando...</span>
                        </div>
                    </div>
                `);
            } else {
                //self.fetchContractSessions(contractId, branchId);
                $(`.js-patient-contract-sessions-btn-${contractId}`).html(`<i class="fas fa-eye-slash"></i> Esconder sessões`);
                //$(`.js-patient-contract-sessions-btn-${contractId}`).prop('disabled', true);
            }
        });

        // Detecta mudança no país selecionado
        $(document).on('change', '#edit_patient_address_country', function () {
            let countryCode = $(this).val();
            if (countryCode) {
                self.fetchStatesByCountry(countryCode);
            } else {
                $('#edit_patient_address_state').html('<option value="">-- Selecione --</option>');
            }
        });
    }

    bindDomTableEvents() {
        let self = this;
        $(document).on('click', `.js-pagination-page-${self.tableHandler.getTableId()}`, function (e) {
            e.preventDefault();
            let pageId = $(this).text();
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchPatientsList();
        });
        $(document).on('click', `.js-pagination-previous-page-${self.tableHandler.getTableId()}`, function (e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() - 1; //console.log('previous pageId', pageId);
            if (pageId <= 0)
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchPatientsList();
        });
        $(document).on('click', `.js-pagination-next-page-${self.tableHandler.getTableId()}`, function (e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() + 1; //console.log('next pageId', pageId);
            if (pageId > self.tableHandler.getMaxPages())
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchPatientsList();
        });
        $(document).on('change', '.js-patients-registrations-start-date-input', function (e) {
            self.startDate = $(this).val();
            self.fetchPatientsList();
        });
        $(document).on('change', '.js-patients-registrations-end-date-input', function (e) {
            self.endDate = $(this).val();
            self.fetchPatientsList();
        });
        $(document).on('change', '.js-patients-per-page', function () {
            self.tableHandler.setRowsPerPage(parseInt($(this).val()));
            self.tableHandler.setCurrentPage(1);
            self.fetchPatientsList();
        });
    }

    bindQueryParams() {
        let self = this;
        let urlParams = new URLSearchParams(window.location.search);
        let patientId = urlParams.get('patient_id');
        let branchId = urlParams.get('branch');

        if (patientId == null || branchId == null)
            return;

        let calledCallback = false;
        this.isLoadingQuerySearch = true;

        $(".js-patients-registrations-table").block(window._loader.loading);

        function OnBusinessReady() {
            if (calledCallback)
                return;
            calledCallback = true;

            //get select options count
            setTimeout(function () {
                // Select branch by name
                if (branchId) {
                    //$(".js-patients-registrations-container").block(window._loader.loading);

                    var intv = setInterval(function () {
                        if (window._sessionData.businessBranches) {
                            //console.log('$(".js-business-branches-selector option:selected").text()', $(".js-business-branches-selector option:selected").text());

                            $(".js-business-branches-selector option").filter(function () {
                                return $(this).text() === branchId;
                            }).prop('selected', true);
                            $(".js-patients-registrations-branches-selector").trigger('change');

                            if (self.selectedBranch == '' || self.selectedBranch == -1)
                                return;

                            clearInterval(intv);

                            $('#js-patients-registrations-search-input').val(patientId).trigger('input');
                        }
                    }, 900);
                }
            }, 500);
        };
        window.businessReadyFunctions.push(OnBusinessReady);
    }

    fetchPatientsList() {
        let self = this;
        $(".js-patients-registrations-table").block(window._loader.loading);
        if (this.fetchRequest) {
            if (typeof this.fetchRequest.abort === 'function')
                this.fetchRequest.abort();
            this.fetchRequest = null;
        }
        this.fetchRequest = apiCall({
            method: 'GET',
            endpoint: 'api/v1/patients',
            data: {
                search: self.searchQuery,
                page: self.tableHandler.getCurrentPage(),
                recordsPerPage: parseInt($('.js-patients-per-page option:selected').val()),
                ...self.selectedBranch !== -1 ? { branchId: self.selectedBranch } : {},
                ...self.startDate !== null && self.endDate !== null ? { startDate: self.startDate, endDate: self.endDate } : {}
            },
            successCallback: function (res) {
                $(".js-patients-registrations-table").unblock();
                if (!res.error) {
                    //console.log('res', res);
                    self.patientsList = res.data;
                    self.patientsTotal = res.total;
                    self.tableHandler.renderPage(self.tableHandler.getCurrentPage(), false, self.patientsList, false, self.patientsTotal);
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function (err) {
                $(".modal-edit-patient-dialog").unblock();
            }
        });
    }

    fetchPatientCurrentAccountData(branch_id, cb = null) {
        let self = this;
        if (!this.isLoadingQuerySearch)
            $(".js-patient-data-container").block(window._loader.loading);
        getBusinessDoctorsListByBranchId(selectedPatient.FILIAL_ID, function () {
            apiCall({
                method: 'GET',
                endpoint: 'api/v1/patient/get_current_account',
                data: {
                    patient: selectedPatient.ID,
                    allContracts: true
                },
                successCallback: function (res) {
                    console.log('crud_patients_registrations.js/patient/get_current_account', 'fetchPatientCurrentAccountData', res);

                    if (cb) {
                        return cb(res);
                    }

                    $(".js-patient-data-container").unblock();
                    $(".js-patients-registrations-container").unblock();
                    $(`.js-patient-sessions-btn-${selectedPatient.ID}`).prop('disabled', false);

                    if (res.error) {
                        window.toast({
                            error: true,
                            text: res.message
                        })
                    } else {
                        if (res.data.length === 0) {
                            return $('.js-patient-sessions-list-' + selectedPatient.ID).html(`Este paciente não possui lançamentos conta corrente.`);
                        }

                        $('.js-patient-sessions-list-' + selectedPatient.ID).html('');

                        let htmlInsrt = '';
                        let contratoAtual = -1;
                        for (let i = 0; i < res.data.length; ++i) {
                            let contaCorrente = res.data[i];

                            let serviceName = '';
                            for (let x = 0; x < self.operatorAllowedServices.length; x++) {
                                let service = self.operatorAllowedServices[x];
                                if (service.ID == contaCorrente.SERVICOS_ID) {
                                    serviceName = service.SERVICO;
                                    break;
                                }
                            }

                            let doctorName = contaCorrente.STAFF_NAME;
                            /*for(let x = 0; x < window.businessBranchDoctors.length; x++) {
                                let doctor = window.businessBranchDoctors[x];
                                if (doctor.DOUTOR_ID == contaCorrente.STAFF_ID) {
                                    doctorName = doctor.PRIMEIRO_NOME;
                                    break;
                                }
                            }*/

                            if (contratoAtual != contaCorrente.CONTRATO_ID) {
                                contratoAtual = contaCorrente.CONTRATO_ID;

                                $('.js-patient-sessions-list-' + selectedPatient.ID).append(`
                                    <table class="mb-0 table table-bordered table-striped table-hover responsive-table">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <button class="btn btn-primary btn-sm js-patient-contract-sessions-toggler js-patient-contract-sessions-btn-${contratoAtual}" data-contract-id="${contratoAtual}" data-branch-id="${contaCorrente.FILIAL_ID}"><i class="fas fa-eye"></i> &nbsp;Ver sessões</button>
                                                    Nr Contrato => ${contratoAtual == 0 ? 'Individual(is)' : ` #${contratoAtual}`}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody class="js-patient-contract-sessions-${contratoAtual} d-none" data-contract-id="${contratoAtual}">
                                            <tr>
                                                <td colspan="12">
                                                    <table class="mb-0 table table-bordered table-striped table-hover responsive-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Cliente ID</th>
                                                                <th>Nr Contrato</th>
                                                                <th>ID</th>
                                                                <th>Data</th>
                                                                <th>Tipo</th>
                                                                <th>Parcela</th>
                                                                <th>Doutor(a)</th>
                                                                <th>Status</th>
                                                                <th>Agenda</th>
                                                                <th>Serviço</th>
                                                                <th>Tipo Paciente</th>
                                                                <th>Alterar Serviço</th>
                                                                ${contratoAtual == '0' ? `
                                                                    <th>Alterar Comissão</th>
                                                                    <th>Excluir</th>
                                                                ` : ''}
                                                            </tr>
                                                        </thead>
                                                        <tbody class="js-patient-contract-table-view-${contratoAtual}">
                                                            <tr>
                                                                <td data-label="Cliente ID">${selectedPatient.ID}</td>
                                                                <td data-label="Nr Contrato">${contratoAtual}</td>
                                                                <td data-label="ID">${contaCorrente.ID}</td>
                                                                <td data-label="Data">${contaCorrente.DATA_FORMATTED}</td>
                                                                <td data-label="Tipo">${contaCorrente.TIPO}</td>
                                                                <td data-label"Parcela">${contaCorrente.PARCELA}</td>
                                                                <td data-label="Doutor(a)">${doctorName}</td>
                                                                <td data-label="Status">${contaCorrente.STATUS ?? ''}</td>
                                                                <td data-label="Agenda">${contaCorrente.DATA_ATENDIMENTO_FORMATTED ?? ''}</td>
                                                                <td data-label="Serviço">${serviceName}</td>
                                                                <td data-label="Tipo Paciente">${contaCorrente.TIPO_PACIENTE ?? ''}</td>
                                                                <td data-label="Alterar serviço"><a href="javascript:void(0);" class="js-patient-current-account-edit-service" data-info='${JSON.stringify(contaCorrente)}'><i class="fas fa-pen"></i></a></td>
                                                                ${contratoAtual == '0' ? `
                                                                    <td data-label="Alterar comissão">${contaCorrente.TIPO != null ? `<a href="javascript:void(0);" class="js-patient-current-account-edit-doctor-comission" data-info='${JSON.stringify(contaCorrente)}'><i class="fas fa-money-bill-wave-alt"></i></a>` : ''}</td>
                                                                    <td data-label="Excluir">${contaCorrente.TIPO != null && contaCorrente.DATA_ATENDIMENTO_FORMATTED === null ? `<a href="javascript:void(0);" class="js-patient-current-account-delete" data-info='${JSON.stringify(contaCorrente)}'><i class="fas fa-trash"></i></a>` : ''}</td>
                                                                ` : ''}
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                `)
                            } else {
                                $('.js-patient-contract-table-view-' + contratoAtual).append(`
                                    <tr>
                                        <td></td>
                                        <td data-label="Nr Contrato">${contratoAtual}</td>
                                        <td data-label="ID">${contaCorrente.ID}</td>
                                        <td data-label="Data">${contaCorrente.DATA_FORMATTED}</td>
                                        <td data-label="Tipo">${contaCorrente.TIPO ?? ''}</td>
                                        <td data-label="Parcela">${contaCorrente.PARCELA ?? ''}</td>
                                        <td data-label="Doutor(a)">${doctorName}</td>
                                        <td data-label="Status">${contaCorrente.STATUS ?? ''}</td>
                                        <td data-label="Agenda">${contaCorrente.DATA_ATENDIMENTO_FORMATTED ?? ''}</td>
                                        <td data-label="Serviço">${serviceName}</td>
                                        <td data-label="Tipo Paciente">${contaCorrente.TIPO_PACIENTE ?? ''}</td>
                                        <td data-label="Alterar serviço"><a href="javascript:void(0);" class="js-patient-current-account-edit-service" data-info='${JSON.stringify(contaCorrente)}'><i class="fas fa-pen"></i></a></td>
                                        ${contratoAtual == '0' ? `
                                            <td data-label="Alterar comissão">${contaCorrente.TIPO != null ? `<a href="javascript:void(0);" class="js-patient-current-account-edit-doctor-comission" data-info='${JSON.stringify(contaCorrente)}'><i class="fas fa-money-bill-wave-alt"></i></a>` : ''}</td>
                                            <td data-label="Excluir">${contaCorrente.TIPO != null ? `<a href="javascript:void(0);" class="js-patient-current-account-delete" data-info='${JSON.stringify(contaCorrente)}'><i class="fas fa-trash"></i></a>` : ''}</td>
                                        ` : ''}
                                    </tr>
                                `);
                            }

                            htmlInsrt += `
                            `;
                        }
                        //console.log('htmlInsrt', htmlInsrt, htmlInsrt.length);
                        /*$('.js-patients-registrations-accordion-container').html(htmlInsrt == '' ? `${selectedPatient.CADASTRO_COMPLETO == 'N' ? 'Complete o cadastro do paciente para ver contratos' : 'Este paciente não possui nenhum contratos.'}` : `
                            <div class="accordion mb-3" id="accordionPatientsRegistrationsContracts">
                                ${htmlInsrt}
                            </div>    
                        `);*/
                    }
                },
                errorCallback: function (err) {
                    $(".js-patient-data-container").unblock();
                    $(`.js-patient-sessions-btn-${selectedPatient.ID}`).prop('disabled', false);
                    //$(".js-patients-registrations-container").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                    console.error('ERROR', 'crud_patients_registrations.js/patient/get_current_account', 'fetchPatientCurrentAccountData', err);
                }
            })
        })
    }

    fetchPatientAnamese(patientInfo) {
        console.log('patientInfo', patientInfo);
        $('#patientServiceModal').modal('show');
        $('#patientName').html(patientInfo.NOME_COMPLETO);
        $('#clientId').html(patientInfo.ID);
        $('#serviceModalpatientId').html(patientInfo.ID);
        $('#patientPhone').html(patientInfo.FONE_CELULAR);
        $('#patientEmail').html(patientInfo.EMAIL);
        $('#patientStatus').html(patientInfo.STATUS == 'S' ? 'Ativo' : 'Inativo');
        $('#patientStatus').removeClass(patientInfo.STATUS == 'S' ? 'badge-danger' : 'badge-success');
        $('#patientStatus').addClass(patientInfo.STATUS == 'S' ? 'badge-success' : 'badge-danger');
        $('#obsHistoryContainer').html(`<div class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
            </div>`);
        $('#patientReportsContainer').html(`<div class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
            </div>`);

        apiCall({
            method: 'GET',
            endpoint: 'api/v1/patient/get_service_history?patient_id=' + patientInfo.ID,
            successCallback: function (res) {
                console.log(res.data);

                const data = res.data;

                // Get most recent date from observation history
                if (data.PatientObsHistory.length > 0) {
                    const mostRecentDate = new Date(data.PatientObsHistory[0].DATA_ATENDIMENTO);
                    $("#recentVisit").text(mostRecentDate.toLocaleDateString());
                }

                // Populate observation history
                let obsHistoryHTML = '';
                if (data.PatientObsHistory.length === 0) {
                    obsHistoryHTML = '<div class="alert alert-info">Sem histórico de observações disponível.</div>';
                } else {
                    data.PatientObsHistory.forEach(obs => {
                        const obsDate = new Date(obs.DATA_ATENDIMENTO);
                        const formattedDate = obsDate.toLocaleDateString();
                        const formattedTime = obsDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

                        obsHistoryHTML += `
                        <div class="card service-card obs-card shadow-sm mb-3">
                            <div class="card-body">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <div>
                                        <span class="date-time"><i class="fas fa-calendar"></i> ${formattedDate} às ${formattedTime}</span>
                                    </div>
                                    <div>
                                        <span class="doctor-name"><i class="fas fa-user-tie"></i> Dr. ${obs.DOUTOR_NOME}</span>
                                    </div>
                                </div>
                                <p class="card-text">${obs.OBSERVACAO}</p>
                                <div class="d-flex justify-content-end">
                                    <span class="badge bg-secondary">Agenda ID: ${obs.AGENDA_ID}</span>
                                </div>
                            </div>
                        </div>
                    `;
                    });
                }
                $("#obsHistoryContainer").html(obsHistoryHTML);

                // Process and populate patient reports
                let reportsHTML = '';
                if (data.PatientReports.length === 0) {
                    reportsHTML = '<div class="alert alert-info">Não existem registros do paciente disponíveis.</div>';
                } else {
                    data.PatientReports.forEach(report => {
                        const reportDate = new Date(report.DATA_RELATO);
                        const formattedReportDate = reportDate.toLocaleDateString();
                        const formattedReportTime = reportDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

                        // Split questions and answers into arrays
                        const questions = report.PERGUNTAS.split(' | ');
                        const answers = report.RESPOSTAS.split(' | ');

                        let questionAnswerHTML = '';
                        for (let i = 0; i < questions.length; i++) {
                            // Remove duplicate questions (noticed in the sample data)
                            if (i > 0 && questions[i] === questions[i - 1]) continue;

                            questionAnswerHTML += `
                        <div class="mb-2">
                            <p class="question mb-1">${questions[i]}</p>
                            <p class="answer mb-0">${answers[i] || 'No response'}</p>
                        </div>
                        `;
                        }

                        reportsHTML += `
                        <div class="card service-card report-card shadow-sm mb-4">
                            <div class="card-header bg-light">
                                <div class="d-flex justify-content-between align-items-center">
                                <span class="date-time"><i class="fas fa-calendar"></i> ${formattedReportDate} às ${formattedReportTime}</span>
                                <span class="doctor-name"><i class="fas fa-user-tie"></i> Dr. ${report.DOUTOR_NOME}</span>
                                </div>
                            </div>
                            <div class="card-body">
                                <h6 class="card-title mb-3">Questionário</h6>
                                ${questionAnswerHTML}
                            </div>
                            <div class="card-footer bg-light">
                                <div class="d-flex justify-content-end">
                                <span class="badge bg-secondary me-2">Relato ID: ${report.ID}</span>
                                <span class="badge bg-secondary">Agenda ID: ${report.AGENDA_ID}</span>
                                </div>
                            </div>
                        </div>
                    `;
                    });
                }
                $("#patientReportsContainer").html(reportsHTML);
            },
            errorCallback: function (res) {
                $('.service-records').html('Ocorreu um erro ao carregar as informações, por favor, tente novamente em instantes...');
                window.toast({
                    error: true,
                    text: "Ocorreu um erro ao carregar histórico de atendimentos do paciente."
                })
            }
        })
    }

    fetchPatientSales(patientInfo) {
        console.log('patientInfo', patientInfo);

        let formData = {
            searchTerm: patientInfo.NOME_COMPLETO,
            showAllPeriod: 1
        }

        $('#js-patient-sales-registrations-container').html(`<div class="d-flex justify-content-center">
            <h6 class="text-primary">Carregando vendas...</h6>
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Carregando...</span>
            </div>
        </div>`);

        apiCall({
            endpoint: 'api/v1/sales',
            method: 'GET',
            data: {
                ...formData
            },
            successCallback: (response) => {
                console.log('response', response);

                if (response.error) {
                    $('#js-patient-sales-registrations-container').html('<div class="alert alert-danger">Não foi possível carregar as vendas do paciente.</div>');
                } else {
                    let approvedSales = response.sold_value_approved;
                    let canceledSales = response.sold_value_canceled;
                    let totalSales = response.sold_value;
                    let html = `
                    <div class="container">
                        <div class="row g-3 mb-3">
                            <div class="col-12">
                                <h6 class="text-dark">Vendas no TheQuiro</h6>
                            </div>
                        </div>
                        <div class="row g-3 mb-3">
                            <div class="col-12 col-md-4">
                                <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                    <div class="text-muted small">Total em vendas em aberto</div>
                                    <div class="h5 mb-0 text-dark">${float2moeda(totalSales)}</div>
                                </div><i class="fas fa-file-alt fs-3 text-primary"></i></div></div></div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                    <div class="text-muted small">Total em vendas aprovadas</div>
                                    <div class="h5 mb-0 text-dark">${float2moeda(approvedSales)}</div>
                                </div><i class="fas fa-calendar-alt fs-3 text-success"></i></div></div></div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="card"><div class="card-body"><div class="d-flex justify-content-between align-items-center"><div>
                                    <div class="text-muted small">Total em vendas canceladas</div>
                                    <div class="h5 mb-0 text-dark">${float2moeda(canceledSales)}</div>
                                </div><i class="fas fa-check-circle fs-3 text-info"></i></div></div></div>
                            </div>
                        </div>
                        <table id="table-patients-sales-list" class="align-middle mb-0 table table-borderless table-striped table-hover responsive-table tbody-cursor-pointer">
                            <thead>
                                <tr>
                                    <th>Filial</th>
                                    <th>Número da venda</th>
                                    <th>Data</th>
                                    <th>Cliente</th>
                                    <th>Valor</th>
                                    <th>Situação</th>
                                    <th>Nota Fiscal</th>
                                </tr>
                            </thead>
                            <tbody class="js-patients-sales-registrations-table">
                                <tr>
                                    <td colspan="7">Carregando....</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    `;
                    $('#js-patient-sales-registrations-container').html(html);

                    html = '';

                    response.data.forEach(sale => {
                        html += `
                            <tr>
                                <td data-label="Filial">${sale.FILIAL}</td>
                                <td data-label="Número da venda">${sale.ID}</td>
                                <td data-label="Data">${moment(sale.DATA_VENDA).tz("America/Sao_Paulo").format('DD/MM/YYYY')}</td>
                                <td data-label="Cliente"><a href="javascript:void(0)" target="new">${sale.CLIENTE_NOME}</a></td>
                                <td data-label="Valor (R$)">${float2moeda(sale.VALOR_TOTAL)}</td>
                                <td data-label="Situação">${window.renderSellStatus(sale.STATUS)}</td>
                                <td data-label="Nota Fiscal">${sale.NOTA_FISCAL_ID ? `Possui nota fiscal ${sale.NOTA_FISCAL_RPS} - ${rowData.NOTA_FISCAL_NUMERO}` : 'Não possui nota fiscal'}</td>
                            </tr>
                        `
                    });

                    if (html !== '') {
                        $('.js-patients-sales-registrations-table').html(html);
                    }
                }
            },
            errorCallback: (err) => {
                console.log('err', err);
            }
        });
    }

    mountTableRow(rowData) {
        let html = '';

        const patientData = escapeSingleQuotes(JSON.stringify(rowData).replace(/"/g, '&quot;'));

        html += `<tr>
            <td data-label="Detalhes">
                <button class="btn btn-${rowData.CADASTRO_COMPLETO == 'N' ? 'secondary' : 'primary'} btn-sm js-patient-sessions-toggler js-patient-sessions-btn-${rowData.ID}" data-patient-id="${rowData.ID}" data-patient-status="${rowData.STATUS}" data-branch-id="${rowData.FILIAL_ID}"><i class="fas fa-eye"></i> &nbsp;Ver contratos</button>
            </td>
            <td data-label="Lanç. Financeiro">
                <button class="btn btn-${rowData.CADASTRO_COMPLETO == 'N' || rowData.TOTAL_CONTRATOS_SEM_ASSINATURA > 0 ? 'secondary' : 'primary js-current-account-add-transaction'}" ${rowData.CADASTRO_COMPLETO == 'N' ? 'disabled' : ''} ${rowData.TOTAL_CONTRATOS_SEM_ASSINATURA > 0 ? 'data-tippy-content="Este paciente possui ' + rowData.TOTAL_CONTRATOS_SEM_ASSINATURA + ' contratos sem finalizar as assinaturas. E por isso não é possível lançar sessões individuais."' : ''} data-patient-info='${patientData}'>
                    <span class="pe-7s-calculator cursor-pointer" style="font-size:32px;"></span>
                </button>
            </td>
            <td data-label="ID">${rowData.ID}</td>
            <td data-label="Nome">${rowData.NOME_COMPLETO} <i class="far fa-copy" data-tippy-content="Copiar nome do paciente" onClick="window.copyToClipboardV2('${rowData.NOME_COMPLETO}');window.toast({error: false, text: 'Nome do paciente copiado com sucesso!'});"></i></td>
            <td data-label="Nascimento">${rowData.DATA_NASCIMENTO_FORMATTED ?? ''}</td>
            <td data-label="CPF/Passaporte">${rowData.CPF != null ? rowData.CPF : (rowData.PASSAPORTE != null ? rowData.PASSAPORTE : '')}</td>
            <td data-label="Celular">${rowData.FONE_CELULAR ?? ''}</td>
            <td data-label="Filial" class="text-end" ${!userHasBranch(rowData.FILIAL_ID) ? 'style="background: #f8d7da; cursor:not-allowed;" data-tippy-content="Você não tem acesso a esta filial."' : ''}>
                ${rowData.FILIAL}
                ${userHasBranch(rowData.FILIAL_ID) || !userHasBranch(rowData.FILIAL_ID) || (userHasRole('ADMIN') || userHasRole('ADMIN_ASSISTANT')) ? `<br />${!userHasBranch(rowData.FILIAL_ID) ? `<span class="badge bg-danger"><i class="fas fa-exclamation-triangle"></i> Você não tem acesso a esta filial.</span><br>` : ''}<a class="btn btn-sm btn-secondary mt-3 js-open-patient-transfer-modal text-white" data-patient-info='${patientData}' data-bs-toggle="modal" data-bs-target="#modal-transfer-patient-and-contracts">Clique para transferir.</a>` : ''}
            </td>
            <td data-label="Cadastro completo" class="text-center" style="${rowData.CADASTRO_COMPLETO == 'S' ? 'background: green; color:white;' : 'background:red; color:black;'}">${rowData.CADASTRO_COMPLETO == 'S' ? 'Sim' : 'Não'}</td>
            <td data-label="C. Corrente" class="text-center" style="${rowData.CONTA_CORRENTE == 'S' ? 'background: green; color:white;' : 'background:red; color:black;'}">${rowData.CONTA_CORRENTE === 'S' ? 'Sim' : 'Não'}</td>
            <td data-label="Primeira agenda">${rowData.PRIMEIRA_AGENDA_ID ?? ''}</td>
            <td data-label="Ações">
                <div class="dropdown">
                    <button class="btn btn-${rowData.CADASTRO_COMPLETO == 'N' ? 'primary js-patient-view-registry' : 'secondary dropdown-toggle'}" type="button" id="leadActionButton" ${rowData.CADASTRO_COMPLETO == 'S' ? 'data-bs-toggle="dropdown" aria-expanded="false"' : ''} data-patient-info="${patientData}">
                        ${rowData.CADASTRO_COMPLETO == 'N' ? 'Completar cadastro' : 'Ações'}
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="leadActionButton">
                        <li><a class="dropdown-item ${rowData.CADASTRO_COMPLETO == 'N' ? 'btn-primary text-white' : 'text-dark'} js-patient-view-registry" href="#" data-patient-info='${patientData}'>${rowData.CADASTRO_COMPLETO == 'N' ? 'Completar' : 'Editar'} Cadastro</a></li>
                        <li><a class="dropdown-item ${rowData.CADASTRO_COMPLETO == 'N' ? 'btn-primary text-white' : 'text-dark'} js-patient-view-contracts" href="#" data-patient-info='${patientData}'>Contratos</a></li>
                        ${rowData.CADASTRO_COMPLETO == 'S' && (userHasRole('ADMIN') || userHasRole('ADMIN_ASSISTANT')) ? `<li><a class="dropdown-item js-patient-view-anamese" data-patient-info='${patientData}'>Visualizar histórico de atendimentos</a></li>` : ''}
                        <li><a class="dropdown-item js-patient-request-courtesy" data-patient-info='${patientData}'>Solicitar cortesia</a></li>
                        <li><a class="dropdown-item js-patient-view-timeline" data-patient-info='${patientData}'>Visualizar informações</a></li>
                    </ul>
                </div>
            </td>
        </tr>
        <!-- sessoes do contrato -->
        <tr class="js-patient-sessions-${rowData.ID} d-none" data-patient-id="${rowData.ID}">
            <td colspan="12" class="js-patient-sessions-list-${rowData.ID}">
                <!-- spinner -->
                <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status">
                        <span class="visually-hidden">Carregando...</span>
                    </div>
                </div>
            </td>
        </tr>`
        return html;
    }

    onRenderPatientInfoData() {
        let self = this;
        let html = `
            <div class="col-12 py-2 js-patients-registration-selected-container">
                <p class="lead">Você está vendo o Cadastro do(a)<br>${selectedPatient.TEXT}</p>

                ${selectedPatient.CADASTRO_COMPLETO == 'N' ? `
                    <div class="alert alert-info" role="alert">
                        <b>ATENÇÃO:</b> Complete o cadastro deste paciente, após isso você poderá lançar contas correntes.
                    </div>` : ''}

                <button class="btn btn-${selectedPatient.CADASTRO_COMPLETO == 'N' ? 'primary' : 'secondary'} js-patient-view-registry">
                    <i class="fas fa-edit"></i> ${selectedPatient.CADASTRO_COMPLETO == 'N' ? 'Completar' : 'Editar'} Cadastro
                </button>
                <button class="btn btn-${selectedPatient.CADASTRO_COMPLETO == 'N' ? 'secondary' : 'primary js-current-account-add-transaction'}" ${selectedPatient.CADASTRO_COMPLETO == 'N' ? 'disabled' : ''}>
                    <i class="fas fa-file-invoice-dollar"></i> Lançar Conta Corrente
                </button>

                <div class="divider my-3"></div>

                <p class="lead">Conta Corrente do Paciente:</p><br>
                <div class="js-patients-registrations-accordion-container"></div>
                
            </div>`;

        $(".js-patient-data-container").append(html);
        $(".js-patient-data-container").removeClass('d-none');

        $('.js-patients-registrations-accordion-container').append(`<div class="accordion mb-3" id="accordionPatientsRegistrationsContracts">Sem conta corrente.</div>`);
        //if (selectedPatient.CONTRATO_ID != null) {
        self.fetchPatientCurrentAccountData();
        /*} else {
            $('.js-patients-registrations-accordion-container').html(`${selectedPatient.CADASTRO_COMPLETO == 'N' ? 'Complete o cadastro do paciente para ver contratos' : 'Este paciente não possui nenhum contratos.'}`);
        }*/
    }

    onFillDocument(document) {
        //console.log('onFillDocument', document);
        $(".modal-edit-patient-dialog").block(window._loader.loading);

        apiCall({
            method: 'GET',
            endpoint: 'api/v1/patient/search_document',
            data: {
                document_type: $('#edit_patient_doc_type').val(),
                document: $('#edit_patient_document').cleanVal()
            },
            successCallback: function (res) {
                $(".modal-edit-patient-dialog").unblock();

                window.toast({
                    error: res.error,
                    text: res.message
                })

                if (res.error) {
                    $("#edit_patient_document").val('');
                }
            },
            errorCallback: function (err) {
                $(".modal-edit-patient-dialog").block(window._loader.error);
            }
        });
    }

    onFillPostalCode(postal_code) {
        $(".modal-edit-patient-dialog").block(window._loader.loading);
        $('.js-edit-patient-postal-code-error').addClass('d-none');

        apiCall({
            method: 'GET',
            endpoint: 'api/v1/cep/find',
            data: {
                postal_code: $('#edit_patient_postal_code').cleanVal()
            },
            successCallback: function (res) {
                $(".modal-edit-patient-dialog").unblock();

                if (res.cep) {
                    if (typeof res.street !== 'undefined' || null) {
                        $('#edit_patient_address').val(res.street);
                        $('#edit_patient_address_neighborhood').val(res.neighborhood);
                        $('#edit_patient_address_city').val(res.city);
                        $('#edit_patient_address_state').val(res.state);
                    } else {
                        $('#edit_patient_address').val(res.logradouro);
                        $('#edit_patient_address_neighborhood').val(res.bairro);
                        $('#edit_patient_address_city').val(res.localidade);
                        $('#edit_patient_address_state').val(res.uf);
                    }
                } else {
                    window.toast({
                        error: true,
                        text: 'Não foi possível encontrar o CEP solicitado.'
                    })
                }
            },
            errorCallback: function (err) {
                $(".modal-edit-patient-dialog").block(window._loader.error);
                $(".modal-edit-patient-dialog").unblock();
                $('.js-edit-patient-postal-code-error').removeClass('d-none');
            }
        });
    }

    fetchStatesByCountry(countryCode) {
        let self = this;
        $(".modal-edit-patient-dialog").block(window._loader.loading);

        // Se for Brasil, usa a lista fixa de estados
        if (countryCode === 'BR') {
            let statesHtml = '<option value="" selected disabled>-- Selecione --</option>';
            const brazilianStates = [
                { code: 'AC', name: 'Acre' },
                { code: 'AL', name: 'Alagoas' },
                { code: 'AP', name: 'Amapá' },
                { code: 'AM', name: 'Amazonas' },
                { code: 'BA', name: 'Bahia' },
                { code: 'CE', name: 'Ceará' },
                { code: 'DF', name: 'Distrito Federal' },
                { code: 'ES', name: 'Espírito Santo' },
                { code: 'GO', name: 'Goiás' },
                { code: 'MA', name: 'Maranhão' },
                { code: 'MT', name: 'Mato Grosso' },
                { code: 'MS', name: 'Mato Grosso do Sul' },
                { code: 'MG', name: 'Minas Gerais' },
                { code: 'PA', name: 'Pará' },
                { code: 'PB', name: 'Paraíba' },
                { code: 'PR', name: 'Paraná' },
                { code: 'PE', name: 'Pernambuco' },
                { code: 'PI', name: 'Piauí' },
                { code: 'RJ', name: 'Rio de Janeiro' },
                { code: 'RN', name: 'Rio Grande do Norte' },
                { code: 'RS', name: 'Rio Grande do Sul' },
                { code: 'RO', name: 'Rondônia' },
                { code: 'RR', name: 'Roraima' },
                { code: 'SC', name: 'Santa Catarina' },
                { code: 'SP', name: 'São Paulo' },
                { code: 'SE', name: 'Sergipe' },
                { code: 'TO', name: 'Tocantins' }
            ];

            brazilianStates.forEach(state => {
                statesHtml += `<option value="${state.code}">${state.name}</option>`;
            });

            $('#edit_patient_address_state').html(statesHtml);
            $(".modal-edit-patient-dialog").unblock();
            return;
        }

        // Para outros países, usa a API REST Countries
        $.ajax({
            url: `https://restcountries.com/v3.1/alpha/${countryCode}`,
            method: 'GET',
            success: function (res) {
                if (res && res[0]) {
                    let statesHtml = '<option value="" selected disabled>-- Selecione --</option>';

                    // Se o país tiver estados/províncias
                    if (res[0].states) {
                        Object.entries(res[0].states).forEach(([code, name]) => {
                            statesHtml += `<option value="${code}">${name}</option>`;
                        });
                    } else {
                        // Se não tiver estados, adiciona uma mensagem
                        statesHtml += '<option value="N/A">Este país não possui estados/províncias</option>';
                    }

                    $('#edit_patient_address_state').html(statesHtml);
                } else {
                    $('#edit_patient_address_state').html('<option value="">-- Selecione --</option>');
                    window.toast({
                        error: true,
                        text: 'Não foi possível obter os estados deste país.'
                    });
                }
                $(".modal-edit-patient-dialog").unblock();
            },
            error: function (err) {
                $('#edit_patient_address_state').html('<option value="">-- Selecione --</option>');
                window.toast({
                    error: true,
                    text: 'Erro ao buscar estados do país selecionado.'
                });
                $(".modal-edit-patient-dialog").unblock();
            }
        });
    }
}

// Função global para toggle das sessões do contrato
window.toggleContractSessions = function (contractId) {
    const $header = $(`.timeline-contract-header[data-contract-id="${contractId}"]`);
    const $sessions = $(`#contract-sessions-${contractId}`);
    const $icon = $header.find('.contract-toggle-icon');

    if ($sessions.hasClass('collapsed')) {
        $sessions.removeClass('collapsed').addClass('expanded');
        $header.removeClass('collapsed');
        $icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
    } else {
        $sessions.removeClass('expanded').addClass('collapsed');
        $header.addClass('collapsed');
        $icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
    }
};